import { combineReducers } from '../../../libraries'
import {
  reducerEvent,
  // reducerAlerts,
  reducerArticleCategory,
  reducerLatest,
  reducerPopular,
  reducerAuth,
  reducerDetailArticle,
  reducerListVotes,
  reducerQuisioner
} from './export'

export const rootReducers = combineReducers({
  listLatest: reducerLatest,
  articleCategory: reducerArticleCategory,
  listEvent: reducerEvent,
  listPopular: reducerPopular,
  auth: reducerAuth,
  detailArticle: reducerDetailArticle,
  listVotes: reducerListVotes,
  listQuisioner: reducerQuisioner
})
